import * as React from 'react';
import { IgcCircularProgressComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A circular progress indicator used to express unspecified wait time or display
 * the length of a process.
 * @slot  - The text area container.
 * @slot gradient - Customize the progress bar in order to use a color gradient instead of a solid color. Accepts `igc-circular-gradient` elements.
 * @csspart svg - The igc-circular-progress SVG element.
 * @csspart gradient_start - The igc-circular-progress linear-gradient start color.
 * @csspart gradient_end - The igc-circular-progress linear-gradient end color.
 * @csspart track - The igc-circular-progress ring track area.
 * @csspart fill - The igc-circular-progress indicator area.
 * @csspart label - The igc-circular-progress label.
 * @csspart value - The igc-circular-progress label value.
 * @csspart indeterminate - The igc-circular-progress indeterminate state.
 * @csspart primary - The igc-circular-progress primary state.
 * @csspart danger - The igc-circular-progress error state.
 * @csspart warning - The igc-circular-progress warning state.
 * @csspart info - The igc-circular-progress info state.
 * @csspart success - The igc-circular-progress success state.
 * @class
 */
export const IgrCircularProgress = /* @__PURE__ */ createComponent({
  tagName: 'igc-circular-progress',
  displayName: 'IgrCircularProgress',
  elementClass: Component,
  react: React,
});

export type IgrCircularProgress = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrCircularProgressModule = Component;
